module.exports = __webpack_public_path__ + "static/media/vf_mouter_core.ea839c3c.svg";